function Raycaster(origin, direction, near, far) {}

export { Raycaster }
